import { render, staticRenderFns } from "./salesDispatchManagement.vue?vue&type=template&id=febc4e2e&scoped=true&"
import script from "./salesDispatchManagement.vue?vue&type=script&lang=js&"
export * from "./salesDispatchManagement.vue?vue&type=script&lang=js&"
import style0 from "./salesDispatchManagement.vue?vue&type=style&index=0&id=febc4e2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "febc4e2e",
  null
  
)

export default component.exports